import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {filterArticle_template} from "./filterArticle_template";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

let quizUniqueIdCounter = 0;

export class quizzesEdit_template extends vnTemplate {

    protected brandsFilter: multipleSelector_template;
    protected filterArticle: filterArticle_template;
    private pendingScrollToNewQuestion: boolean = false;

    protected getTemplateHtml(): string {
        return /* html */ `
            <div class="w-form w-form-large form-poll quiz-edit-layout">
                <div class="form-header">
                    <input id="quiz-id" data-bind="value: id" type="hidden">
                    <h3 class="form-title icon i-poll" data-bind="text: id() != null ? 'Edit Quiz' : 'Add Quiz'"></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>

                <div class="w-form-body quiz-picker-scroll">
                    <div id="quiz-picker-info-section" class="w-poll-body quiz-picker-info-section">
                        <div class="w-form-body w-poll-sections-list">
                            <div class="form-body">
                                <div class="form-group quiz-picker-section-heading">
                                    <label for="quiz-title" class="form-label quiz-picker-section-heading__label">Title</label>
                                </div>
                                <div class="form-group quiz-picker-title-input">
                                    <input id="quiz-title" class="input-text" type="text" data-bind="value: title, valueUpdate: 'keyup'">
                                </div>

                                <div class="form-group quiz-picker-brands-row">
                                    <div class="quiz-picker-brands-filter">
                                        ${this.brandsFilter.getHtmlBuild()}
                                    </div>
                                    <div id="selected-brands" class="quiz-picker-brand-tags"></div>
                                </div>
                            </div>

                            <div class="quiz-picker-article-section">
                                <div class="form-group quiz-picker-section-heading">
                                    <label class="form-label quiz-picker-section-heading__label">Source Article</label>
                                </div>
                                <div class="form-body quiz-picker-article-panel">
                                    <div class="form-group quiz-picker-article-search">
                                        <div class="quiz-picker-article-search__field">
                                            ${this.filterArticle.getHtmlBuild()}
                                        </div>
                                    </div>

                                    <div class="w-filters-selected quiz-picker-selected-articles">
                                        <strong>Selected Articles:</strong>
                                        <div id="selected-source-article" class="filters-selected"></div>
                                    </div>

                                    <div class="form-group quiz-picker-generate-actions">
                                        <button data-bind="event: { click: onClickGenerate }, enable: idSourceArticle" class="btn secondary" type="button">Generate from Article</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="widgets-section-quiz" class="w-poll-body quiz-picker-widgets-section">
                        <div class="w-form-body w-poll-sections-list">
                            <div class="form-body">
                                <div class="form-group widget-controls">
                                    <button class="btn-fab btn-fab--small rounded secondary icon-end" type="button" data-bind="event: { click: onClickAddQuiz }">
                                        <div class="icon i-plus"></div>
                                        <div class="fab-label">Add Question</div>
                                    </button>
                                    <span class="widget-controls__alert" data-bind="visible: isQuizContentInvalid()">Incomplete content will not sync to the website.</span>
                                    <button class="quiz-picker-toggle-all-btn" type="button" data-bind="visible: quizQuestions().length > 0, event: { click: onClickToggleAllQuizQuestions }, text: toggleAllQuizLabel"></button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" data-bind="foreach: quizQuestions, childrenComplete: handleDragAndDrop($element, quizQuestions, '.quiz-question-block', { collapseOnDrag: true, dragHandleSelector: '.drag-handle' })">
                            <div class="quiz-question-block" data-bind="attr: { 'data-is-from': isFromAi() ? 'ai' : 'user' }">
                                <div class="quiz-question-block__header">
                                    <div class="quiz-question-block__title">
                                        <span class="icon i-drag drag-handle"></span>
                                        <strong class="quiz-question-block__index" data-bind="text: 'Question ' + ($index() + 1), click: toggleCollapsed"></strong>
                                        <button class="btn-fab no-style icon-only icon--xlarge icon i-dropdown-simple" data-bind="click: toggleCollapsed, css: { 'is-open' : !isCollapsed() }" type="button"></button>
                                        <span class="quiz-question-block__preview" data-bind="visible: isCollapsed, text: question() ? ': ' + question() : '', click: toggleCollapsed"></span>
                                    </div>
                                    <button class="btn border only-icon icon i-delete" type="button" title="Remove Question" data-bind="event: { click: function() { $parent.onClickRemoveQuizQuestion($index()) } }"></button>
                                </div>

                                <div class="quiz-question-block__body" data-bind="visible: !isCollapsed()">
                                    <div class="quiz-question-field-row">
                                        <label class="form-label">Question</label>
                                        <textarea class="input-text quiz-question-input" data-bind="value: question, valueUpdate: 'input'" placeholder="Enter question text"></textarea>
                                    </div>

                                    <div class="quiz-question-field-row quiz-question-field-row--split">
                                        <div class="quiz-question-field">
                                            <label class="form-label">Difficulty</label>
                                            <select class="input-text" data-bind="value: difficulty">
                                                <option value="easy">Easy</option>
                                                <option value="medium">Medium</option>
                                                <option value="hard">Hard</option>
                                            </select>
                                        </div>
                                        <div class="quiz-question-field">
                                            <label class="form-label">Basis</label>
                                            <select class="input-text" data-bind="value: basis">
                                                <option value="article">Article</option>
                                                <option value="topic">Topic</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="quiz-question-field-row">
                                        <label class="form-label">Rationale</label>
                                        <textarea class="input-text quiz-question-input quiz-question-input--tall" data-bind="value: rationale, valueUpdate: 'input'" placeholder="Rationale for correct answer"></textarea>
                                    </div>

                                    <div class="quiz-options">
                                        <label class="form-label">Answer Options</label>
                                        <div data-bind="foreach: options">
                                            <div class="quiz-option-row">
                                                <input type="text" class="input-text quiz-question-input" data-bind="value: text, valueUpdate: 'input'" placeholder="Option text" />
                                                <label class="quiz-option-correct-label">
                                                    <input type="radio"
                                                        data-bind="checked: $parent.correctOptionIndex, checkedValue: $index(), attr: { name: 'correctOption' + $parent.uniqueId }" />
                                                    Correct
                                                </label>
                                                <button class="btn border only-icon icon i-delete" type="button" title="Remove Option" data-bind="event: { click: function() { $parents[1].onClickRemoveQuizOption($parent, $index()) } }"></button>
                                            </div>
                                        </div>
                                        <button class="btn" type="button" data-bind="event: { click: function() { $parent.onClickAddQuizOption($data) } }">+ Add Option</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
            </div>
        `;
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector, options = {}): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector, options);

        if (this.pendingScrollToNewQuestion) {
            this.pendingScrollToNewQuestion = false;
            const children = element.querySelectorAll(childrenSelector);
            const lastChild = children[children.length - 1];
            if (lastChild) {
                lastChild.scrollIntoView({behavior: "smooth", block: "start"});
            }
        }
    }

    protected initPartial(): void {
        this.brandsFilter = new multipleSelector_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.brandsFilter.setLabel("Brands");
        this.brandsFilter.setFilterContainerClass('margin-neg');
        this.brandsFilter.setTagContainerId('selected-brands');
        this.brandsFilter.setTagContainerCaption('');

        this.filterArticle = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.filterArticle.setSelectionMode(filterArticle_template.MULTIPLE_SELECTION_MODE);
        this.filterArticle.setShowDetails(true);
        this.filterArticle.setShowSelectedArticlesDetails(true);
        this.filterArticle.setTagContainerId("selected-source-article");
        this.filterArticle.setIsLoadingAnimationEnable(true);
    }

    protected getTemplateName(): string {
        return "quizzesEdit-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        let self = this;
        return {
            id: ko.observable(null),
            brandId: ko.observable(null),
            title: ko.observable(""),
            idSourceArticle: ko.observable(null),
            idSourceArticleBrand: ko.observable(null),
            quizQuestions: ko.observableArray([]),
            isQuizContentInvalid: ko.pureComputed(() => {
                const quizQuestions = self.getTemplateViewModel().quizQuestions();
                if (!quizQuestions || quizQuestions.length === 0) {
                    return false;
                }

                return quizQuestions.some(question => {
                    if (question && typeof question.isQuestionValid === "function") {
                        return !ko.unwrap(question.isQuestionValid);
                    }

                    return false;
                });
            }),
            toggleAllQuizLabel: ko.pureComputed(() => {
                const quizQuestions = self.getTemplateViewModel().quizQuestions();
                const anyExpanded = quizQuestions.some(question => !ko.unwrap(question.isCollapsed));
                return anyExpanded ? "Collapse All" : "Expand All";
            }),
            onClickToggleAllQuizQuestions: function () {
                self.toggleAllQuizQuestions();
            },
            onClickAddQuiz: function () {
                self.addQuizQuestion();
            },
            onClickAddQuizOption: function (question) {
                self.addQuizOption(question);
            },
            onClickRemoveQuizOption: function (question, optionIndex) {
                self.removeQuizOption(question, optionIndex);
            },
            onClickRemoveQuizQuestion: function (questionIndex) {
                self.removeQuizQuestion(questionIndex);
            },
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onClickGenerate: (data, event) => {
                self.onClickGenerate();
            },
            onClickCancel: (data, event) => {
                self.onClickCancel(data);
            },
            handleDragAndDrop: (element, currentObservableArray, childrenSelector, options = {}) => {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector, options);
            },
        };
    }

    protected buildQuizQuestion(questionData): any {
        const question = ko.observable(questionData.question || "");
        const rationale = ko.observable(questionData.rationale || questionData.answer || "");
        const options = ko.observableArray((questionData.options || []).map((option) => ({
            text: ko.observable(option.text || option.option || option.choiceText || ""),
            isCorrect: ko.observable(option.isCorrect === true || option.isCorrect === "on")
        })));
        const foundIndex = (questionData.options || []).findIndex(option => option.isCorrect === true || option.isCorrect === "on");

        const quizQuestion = {
            uniqueId: questionData.uniqueId || "quiz_" + (++quizUniqueIdCounter),
            isValid: questionData.isValid || false,
            question: question,
            difficulty: ko.observable(questionData.difficulty || "easy"),
            basis: ko.observable(questionData.basis || "topic"),
            rationale: rationale,
            correctOptionIndex: ko.observable(foundIndex !== -1 ? foundIndex : this.getCorrectOptionIndexFromAnswer(questionData)),
            isCollapsed: ko.observable(false),
            isFromAi: ko.observable(questionData.isFromAi === true),
            toggleCollapsed: function () {
                this.isCollapsed(!this.isCollapsed());
            },
            isQuestionValid: null,
            options: options
        };

        quizQuestion.isQuestionValid = ko.pureComputed(() => {
            const qVal = question() || "";
            const rVal = rationale() || "";
            const opts = options() || [];
            if (qVal.trim() === "" || rVal.trim() === "" || opts.length === 0) {
                return false;
            }

            return opts.every(option => option.text().trim() !== "");
        });

        return quizQuestion;
    }

    protected getCorrectOptionIndexFromAnswer(questionData): number {
        const answer = questionData.answer || "";
        if (!answer || !questionData.options) {
            return 0;
        }

        const index = questionData.options.findIndex((option) => {
            const optionText = option.text || option.option || option.choiceText || "";
            return optionText === answer;
        });

        return index !== -1 ? index : 0;
    }

    public setReferences(references): void {
        this.setBrandsReferences(references.brands || []);
    }

    public setBrandsReferences(brands): void {
        this.brandsFilter.setItems(brands || []);
    }

    public setArticlesFilter(articles): void {
        this.filterArticle.setShowDetails(true);
        this.filterArticle.setOptions(this.formatSourceArticlesForDisplay(articles || []));
    }

    public setQuiz(data, currentBrandId): void {
        const mappedQuestions = (data.quiz || []).map(question => this.buildQuizQuestion(question));

        this.setBrandId(currentBrandId);
        this.setId(data.id || null);
        this.setTitle(data.title || "");
        this.setIdSourceArticle(data.idSourceArticle || null);
        this.setIdSourceArticleBrand(data.idSourceArticleBrand || null);
        this.setSelectedSourceArticle(data.sourceArticle || data.article || null);
        this.setQuizQuestions(mappedQuestions);
        this.setAttachedBrandIds((data.brands && data.brands.length > 0) ? data.brands : [currentBrandId]);
    }

    public getQuizForRequest(regenerate): any {
        return this.getViewModelForRequest(regenerate);
    }

    public getViewModelForRequest(regenerate = false): any {
        const quizQuestionsRaw = ko.toJS(this.getTemplateViewModel().quizQuestions());

        quizQuestionsRaw.forEach(q => {
            if (q.options) {
                q.options.forEach((option, index) => {
                    option.isCorrect = (q.correctOptionIndex === index) ? "on" : undefined;
                });
            }

            const questionModel = this.getTemplateViewModel().quizQuestions().find(question => question.uniqueId === q.uniqueId);
            q.isValid = questionModel ? questionModel.isQuestionValid() : false;
            delete q.correctOptionIndex;
        });

        return {
            id: this.getId(),
            title: this.getTitle(),
            idSourceArticle: this.getIdSourceArticle(),
            idSourceArticleBrand: this.getIdSourceArticleBrand(),
            brands: this.brandsFilter.getSelectedItems(),
            quiz: quizQuestionsRaw,
            regenerate: regenerate
        };
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public setBrandId(brandId): void {
        this.getTemplateViewModel().brandId(brandId);
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public setTitle(title): void {
        this.getTemplateViewModel().title(title);
    }

    public getTitle() {
        return this.getTemplateViewModel().title();
    }

    public setIdSourceArticle(idSourceArticle): void {
        this.getTemplateViewModel().idSourceArticle(idSourceArticle);
    }

    public getIdSourceArticle() {
        const selectedArticle = this.getSelectedSourceArticle();
        return selectedArticle && selectedArticle.id ? selectedArticle.id : this.getTemplateViewModel().idSourceArticle();
    }

    public setIdSourceArticleBrand(idSourceArticleBrand) {
        this.getTemplateViewModel().idSourceArticleBrand(idSourceArticleBrand);
    }

    public getIdSourceArticleBrand() {
        return this.getTemplateViewModel().idSourceArticleBrand();
    }

    public syncSelectedSourceArticle(): void {
        const selectedArticle = this.getSelectedSourceArticle();
        this.setIdSourceArticle(selectedArticle && selectedArticle.id ? selectedArticle.id : null);
    }

    protected getSelectedSourceArticle(): any {
        const selectedArticles = this.filterArticle.getArticleObjs();
        if (selectedArticles && selectedArticles.length > 0) {
            const selectedArticle = selectedArticles[selectedArticles.length - 1];
            if (selectedArticles.length > 1) {
                this.filterArticle.resetArticleContainer();
                this.filterArticle.setArticles(selectedArticle);
            }

            return selectedArticle;
        }

        return this.filterArticle.getArticleObj();
    }

    public setSelectedSourceArticle(article): void {
        if (article && article.id) {
            this.filterArticle.resetArticleContainer();
            this.filterArticle.setArticles(this.formatSourceArticleForDisplay(article));
            this.setIdSourceArticle(article.id);
            return;
        }

        const idSourceArticle = this.getTemplateViewModel().idSourceArticle();
        if (idSourceArticle) {
            this.filterArticle.resetArticleContainer();
            this.filterArticle.setArticles(this.formatSourceArticleForDisplay({
                id: idSourceArticle,
                title: "Article #" + idSourceArticle,
                brandName: this.getSourceArticleBrandName(),
            }));
        } else {
            this.filterArticle.resetArticleContainer();
        }
    }

    protected formatSourceArticlesForDisplay(articles): Array<any> {
        return (articles || []).map((article) => this.formatSourceArticleForDisplay(article));
    }

    protected formatSourceArticleForDisplay(article): any {
        if (!article) {
            return article;
        }

        return {
            ...article,
            title: this.getSourceArticleDisplayTitle(article),
        };
    }

    protected getSourceArticleDisplayTitle(article): string {
        const title = article.title || "";
        const id = article.id || "";
        const brandName = this.getSourceArticleBrandName(article);

        return `${title} (${id} - ${brandName})`;
    }

    protected getSourceArticleBrandName(article = null): string {
        if (article) {
            const articleBrandName = article.brandName || article.brandShortName || article.brand || article.shortName;
            if (articleBrandName) {
                return articleBrandName;
            }
        }

        const sourceArticleBrandId = this.getTemplateViewModel().idSourceArticleBrand();
        const brand = (this.brandsFilter.getItems() || []).find((brandReference) => {
            return Number(brandReference.id) === Number(sourceArticleBrandId);
        });

        return brand ? (brand.name || brand.shortName || "") : "";
    }

    public setQuizQuestions(quizQuestions): void {
        this.getTemplateViewModel().quizQuestions(quizQuestions);
    }

    public setAttachedBrandIds(brandIds): void {
        const selectedBrandIds: Array<number> = Array.from(new Set((brandIds || []).map((brandId) => Number(brandId))));
        this.brandsFilter.setSeletedItemIds(selectedBrandIds, false);
        this.brandsFilter.setTags(selectedBrandIds, this.brandsFilter.getItems());
    }

    public onClickSave(): void {
        this.caller.saveQuiz(false);
    }

    public onClickGenerate(): void {
        this.caller.saveQuiz(true);
    }

    public onClickCancel(data): void {
        this.caller.cancel(this.getId(), this.getBrandId());
    }

    public addQuizQuestion(): void {
        const quizQuestions = this.getTemplateViewModel().quizQuestions;
        const existingQuestions = quizQuestions();

        if (existingQuestions && existingQuestions.length > 0) {
            if (existingQuestions.length > quizUniqueIdCounter) {
                quizUniqueIdCounter = existingQuestions.length;
            }

            existingQuestions.forEach(question => {
                const uid = question.uniqueId;
                if (uid && typeof uid === "string" && uid.startsWith("quiz_new_")) {
                    const num = parseInt(uid.replace("quiz_new_", ""), 10);
                    if (!isNaN(num) && num > quizUniqueIdCounter) {
                        quizUniqueIdCounter = num;
                    }
                }
            });
        }

        this.pendingScrollToNewQuestion = true;

        quizQuestions.push(this.buildQuizQuestion({
            uniqueId: "quiz_new_" + (++quizUniqueIdCounter),
            question: "",
            difficulty: "easy",
            basis: "topic",
            rationale: "",
            options: [
                {text: ""},
                {text: ""},
                {text: ""},
                {text: ""}
            ]
        }));
    }

    public toggleAllQuizQuestions(): void {
        const quizQuestions = this.getTemplateViewModel().quizQuestions();
        if (quizQuestions.length === 0) {
            return;
        }

        const anyExpanded = quizQuestions.some(question => !ko.unwrap(question.isCollapsed));
        quizQuestions.forEach(question => {
            if (typeof question.isCollapsed === "function") {
                question.isCollapsed(anyExpanded);
            }
        });
    }

    public addQuizOption(question): void {
        question.options.push({text: ko.observable(""), isCorrect: ko.observable(false)});
    }

    public removeQuizOption(question, optionIndex): void {
        question.options.splice(optionIndex, 1);
        const correctIndex = ko.unwrap(question.correctOptionIndex);
        if (correctIndex >= question.options().length) {
            question.correctOptionIndex(Math.max(question.options().length - 1, 0));
        }
    }

    public removeQuizQuestion(questionIndex): void {
        this.getTemplateViewModel().quizQuestions.splice(questionIndex, 1);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/quizzesEdit_template.ts